import { render, staticRenderFns } from "./relic-detail-census.vue?vue&type=template&id=78065fe6"
import script from "./relic-detail-census.vue?vue&type=script&lang=js"
export * from "./relic-detail-census.vue?vue&type=script&lang=js"
import style0 from "./relic-detail-census.vue?vue&type=style&index=0&id=78065fe6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports